import React, { useCallback, useImperativeHandle, useRef, useState } from "react";
import { isEqual, isFunction } from "@Util/utils";
import TrendAreaChartDialog from "./TrendAreaChartDialog";
import TrendLineChartDialog from "./TrendLineChartDialog";

const TREND_AREA_CHART_DIALOG = "TrendAreaChartDialog";
const TREND_LINE_CHART_DIALOG = "TrendLineChartDialog";

const TrendChartDialogBox = React.forwardRef((props, ref) => {
	const [openDialog, setOpenDialog] = useState("");
	const [sourceData, setSourceData] = useState(null);
	const refreshRef = useRef(null);

	const handleDialogClose = useCallback(
		() => {
			setOpenDialog(null);
			setSourceData(null);
			refreshRef.current = null;
		},
		// eslint-disable-next-line
		[],
	);

	const doRefresh = (...arg) => {
		if (isFunction(refreshRef.current)) {
			setTimeout(() => refreshFn(...arg), 5);
		}
		const refreshFn = refreshRef.current;
		console.log("refreshFn", refreshFn);
	};

	useImperativeHandle(
		ref,
		() => ({
			// 開啟堆疊區域圖Dialog
			openTrendAreaChartDialog: (sourceData, refreshFn) => {
				refreshRef.current = refreshFn;
				setSourceData(sourceData);
				setOpenDialog(TREND_AREA_CHART_DIALOG);
			},
			// 開啟折線圖Dialog
			openTrendLineChartDialog: (sourceData, refreshFn) => {
				refreshRef.current = refreshFn;
				setSourceData(sourceData);
				setOpenDialog(TREND_LINE_CHART_DIALOG);
			},
			// 關閉彈窗
			closeDialog: () => {
				handleDialogClose();
			},
		}),
		// eslint-disable-next-line
		[handleDialogClose],
	);

	return (
		<React.Fragment>
			<TrendAreaChartDialog open={isEqual(openDialog, TREND_AREA_CHART_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
			<TrendLineChartDialog open={isEqual(openDialog, TREND_LINE_CHART_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
		</React.Fragment>
	);
});

export default TrendChartDialogBox;
